import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import InventoryitemEditFormImpl from './InventoryitemEditFormImpl';
import InventoryitemList from './InventoryitemList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import InventoryitemListView from './InventoryitemListView'


export default function InventoryitemDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.manufslice.inventoryitemDashboard);
  const [ inventoryitemId, setInventoryitemId] = React.useState('');
  const [reloadInventoryitemList, setReloadInventoryitemList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <InventoryitemEditFormImpl 
            setReloadInventoryitemList={setReloadInventoryitemList}
            inventoryitemId={inventoryitemId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <InventoryitemListView 
                      setInventoryitemId = {setInventoryitemId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
